import {useEffect, useRef, useState} from 'react';

export const useTooltip = (hasExtraData = true) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [coords, setCoords] = useState({top: 0, left: 0, center: 0});

    const containerRef = useRef(null);
    const [cellId] = useState(() => Math.random().toString(36).substr(2, 9));

    const updateCoords = () => {
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();

            setCoords({
                top: rect.top,
                left: rect.left,
                center: rect.left + rect.width / 2,
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsClicked(false);
            }
        };

        const handleOtherCellOpened = (event) => {
            if (event.detail !== cellId) {
                setIsClicked(false);
            }
        };

        const handleScroll = () => {
            setIsClicked(false);
            setIsHovered(false);
        };

        if (isClicked) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        document.addEventListener('sourceCellOpened', handleOtherCellOpened);
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('sourceCellOpened', handleOtherCellOpened);
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [isClicked, cellId]);

    const handleMouseEnter = () => {
        if (hasExtraData) {
            updateCoords();
            document.dispatchEvent(new CustomEvent('sourceCellOpened', {detail: cellId}));
            setIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleClick = (e) => {
        if (hasExtraData) {
            e.preventDefault();
            e.stopPropagation();

            if (!isClicked) {
                updateCoords();
                document.dispatchEvent(new CustomEvent('sourceCellOpened', {detail: cellId}));
            }
            setIsClicked(!isClicked);
        }
    };

    const isVisible = hasExtraData && (isHovered || isClicked);

    return {
        containerRef,
        isVisible,
        coords,
        handleMouseEnter,
        handleMouseLeave,
        handleClick,
    };
};
